import {
  QueryFetchType,
  usePaginatedOrInfiniteQuery,
  UseQueryProps,
} from '@starsoft/common/hooks';
import { BetsSortAndFilterQuery } from '@/services/dto/bet/me/bets-sort-and-filter-query.query';
import { useBetsMeInfinity } from './infinity';
import { useBetsMeDefault } from './default';
import { DetailedBet } from '@/models/detailed-bet';

export function useBetsMe<
  T extends QueryFetchType,
  K extends BetsSortAndFilterQuery,
>(options?: UseQueryProps<T, K>) {
  return usePaginatedOrInfiniteQuery<T, DetailedBet[]>(
    {
      ...options,
    },
    useBetsMeInfinity,
    useBetsMeDefault,
  );
}
